export enum EAuthStage {
    NotStarted = 0,
    Code = 1
}

export enum EAuthSendCodeMethod {
    FlashCall = 0,
    TelegramOrSms = 1
}

export interface IAuthSendCodeResponse {
    success: boolean
    sendCodeMethod: EAuthSendCodeMethod
    message: string
    codeLength: number
    expirationSeconds: number
}
